/**
 * Spot WebSocket API
 *
 * Access market data, manage accounts, and trade on Binance Spot.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { WebsocketAPIBase, ConfigurationWebsocketAPI } from '@binance/common';
import { WebsocketAPIConnection } from './websocket-api-connection';

export class WebsocketAPI {
    private configuration: ConfigurationWebsocketAPI;

    constructor(configuration: ConfigurationWebsocketAPI) {
        this.configuration = configuration;
    }

    /**
     * Connects to the Binance WebSocket API and returns a `WebsocketAPIConnection` instance.
     *
     * @param {object} [options] - Optional connection options.
     * @param {string} [options.mode='single'] - The connection mode, either 'single' or 'pool'. Overrides the `mode` property in the configuration.
     * @param {number} [options.poolSize=1] - The number of connections to use in pool mode. Overrides the `poolSize` property in the configuration.
     * @returns {Promise<WebsocketAPIConnection>} - A promise that resolves to a `WebsocketAPIConnection` instance.
     */
    async connect({
        mode,
        poolSize,
    }: { mode?: 'single' | 'pool'; poolSize?: number } = {}): Promise<WebsocketAPIConnection> {
        const websocketBase = new WebsocketAPIBase({
            ...this.configuration,
            ...(mode && { mode }),
            ...(poolSize && { poolSize }),
        });
        const websocketAPIConnection = new WebsocketAPIConnection(websocketBase);
        await websocketBase.connect();
        return websocketAPIConnection;
    }
}
